import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CSSProperties } from 'react';

type UseSortableItemOptions = {
  id: string;
  style?: CSSProperties;
};

export const useSortableItem = ({ id, style }: UseSortableItemOptions) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return {
    setNodeRef,
    isDragging,
    dragHandleProps: { ...attributes, ...listeners },
    style: {
      ...style,
      transform: CSS.Transform.toString(transform),
      transition,
    },
  };
};
